module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cases/css/case-crud.component.css
// module id = ./src/app/modules/cases/css/case-crud.component.css
// module chunks = main